import s from './home.module.css';

export default function PlatformsSection() {
  return (
    <section id="platforms">
      <div className="container">
        <span className={s.sectionLabel}>Wherever you work</span>
        <h2 className={s.sectionTitle}>Three surfaces. One file.</h2>
        <p className={s.sectionLead}>
          Your matter is the same wherever you open it &mdash; web for desk work, macOS for deep drafting,
          iOS for hearings and on-the-go review.
        </p>
        <div className={s.platforms}>
          <Tile icon="/ WEB" name="avowal.ai" status="In private beta" />
          <Tile icon="/ MACOS" name="AVOWAL Desktop" status="Mac App Store &mdash; coming Q3" />
          <Tile icon="/ IOS" name="AVOWAL Mobile" status="App Store &mdash; coming Q3" />
        </div>
      </div>
    </section>
  );
}

function Tile({ icon, name, status }: { icon: string; name: string; status: string }) {
  return (
    <div className={s.platform}>
      <div className={s.platformIcon}>{icon}</div>
      <div className={s.platformName}>{name}</div>
      <div className={s.platformStatus} dangerouslySetInnerHTML={{ __html: status }} />
    </div>
  );
}
